import Vue from 'vue'
import VueRouter from 'vue-router'
import { whitelist } from '@/router/whitelist'
import { goldenIdeas } from '@/router/goldenIdeas'
import { userlist } from '@/router/user'
const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    redirect: '/login'
  },
  {
    path: '/login',
    component: () => import('@/views/login.vue')
  },
  {
    path: '/dashboard',
    component: () => import('@/layouts/dashboard'),
    redirect: '/dashboard',
    children: [
      {
        path: '/dashboard',
        label: '白名单管理',
        sort: '1',
        hidden: false,
        showMenus: false,
        icon: 'el-icon-s-custom',
        redirect: '/userlist',
        component: () => import('@/layouts/main-container'),
        children: userlist
      },
      {
        path: '/whitelist',
        label: '子公司管理',
        sort: '2',
        icon: 'el-icon-info',
        hidden: true,
        showMenus: false,
        redirect: '/whitelist/index',
        component: () => import('@/layouts/main-container'),
        children: whitelist
      },
      {
        path: '/goldenIdeas',
        label: '金点子管理',
        sort: '3',
        icon: 'el-icon-message-solid',
        hidden: false,
        showMenus: false,
        redirect: '/goldenIdeas/index',
        component: () => import('@/layouts/main-container'),
        children: goldenIdeas
      },
      {
        path: '/personal-settings/index',
        label: '个人设置',
        sort: '4',
        icon: 'index',
        hidden: true,
        component: () => import('@/views/personal-settings/index')
      }
    ]
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
